import { useWindowEvent } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import Link$1 from '../../basics/Link/Link.js';
import Logo$1 from '../../basics/Logo/Logo.js';
import StyledFooter from './Footer.style.js';

const Footer = (_ref) => {
  let {
    links,
    mainLinks,
    homeLink
  } = _ref,
      props = _objectWithoutProperties(_ref, ["links", "mainLinks", "homeLink"]);

  useWindowEvent('click', e => {
    if (e.target.href && e.target.href.includes('#cf-banner-show')) {
      e.preventDefault();
      window.CookieFirst.openPanel();
    }
  });
  return /*#__PURE__*/React$1.createElement(StyledFooter, props, /*#__PURE__*/React$1.createElement("div", {
    className: "footer__wrapper"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "footer__icon"
  }, /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "signet"
  })), links && links.length > 0 && /*#__PURE__*/React$1.createElement("div", {
    className: "footer__social-media"
  }, /*#__PURE__*/React$1.createElement("ul", null, links.map(link => link ? /*#__PURE__*/React$1.createElement("li", {
    key: link.socialService
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    noHover: true,
    className: link.isActive ? 'is-active' : ''
  }, link, {
    icon: null
  }), /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: link.socialService,
    alignment: "none"
  }))) : null))), /*#__PURE__*/React$1.createElement("div", {
    className: "footer__main-navigation"
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({}, homeLink, {
    noHover: true,
    "aria-label": "Home",
    className: "footer__logo"
  }), /*#__PURE__*/React$1.createElement(Logo$1, {
    fillColor: "accent"
  })), mainLinks && mainLinks.length > 0 && /*#__PURE__*/React$1.createElement("ul", null, mainLinks.map(link => link ? /*#__PURE__*/React$1.createElement("li", {
    key: link.label
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    noHover: true,
    className: link.isActive ? 'is-active' : ''
  }, link, {
    icon: null
  }), link.label)) : null)))));
};

Footer.propTypes = {
  homeLink: PropTypes$1.shape(),
  mainLinks: PropTypes$1.arrayOf(PropTypes$1.shape()),
  links: PropTypes$1.arrayOf(PropTypes$1.shape())
};
Footer.defaultProps = {
  homeLink: null,
  mainLinks: null,
  links: null
};

export default Footer;
